import { put, takeLatest, call } from 'redux-saga/effects'
import fetchFromAPI, { getDefaultAutorizedHeaders } from 'helpers/fetchFromApi'
import UrlHelper from 'helpers/url'
import * as ApiRoute from 'constants/apiRouting'
import NoticeHelper from 'helpers/notice'
import {
  FETCH_SITE_LIST,
  SUCCESS_SITE_LIST,
  FAILURE_SITE_LIST,
  FETCH_SENSOR_TYPES,
  SUCCESS_SENSOR_TYPES,
  FAILURE_SENSOR_TYPES,
  FETCH_SENSOR_NAMES,
  SUCCESS_SENSOR_NAMES,
  FAILURE_SENSOR_NAMES,
  FETCH_SITE_TYPES,
  SUCCESS_SITE_TYPES,
  FAILURE_SITE_TYPES,
  FETCH_SENSORS_DATA,
  SUCCESS_SENSORS_DATA,
  FAILURE_SENSORS_DATA,
  SET_SENSORS_CHART_LOADER,
  SET_CUSTOM_SENSOR_LIMITS,
  REFRESH_SENSOR_CHART_DATA,
} from './reducer'
import { SHOW_NOTICE } from '../notice'

function* fetchSiteList({ payload }) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: UrlHelper.createQuery(ApiRoute.ACTIVE_SITES, payload.params),
    })

    if (response && !response.hasOwnProperty('error')) {
      yield put({ type: SUCCESS_SITE_LIST, payload: response })
    } else {
      yield put({ type: FAILURE_SITE_LIST })
    }
  } catch (error) {
    console.log('FETCH SENSOR SITE LIST FAILED ', error)
  }
}

function* fetchSensorTypes(action) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: UrlHelper.create(ApiRoute.SENSOR_TYPES, action.payload),
    })

    if (response && !response.hasOwnProperty('error')) {
      yield put({ type: SUCCESS_SENSOR_TYPES, payload: response })
    } else {
      yield put({ type: FAILURE_SENSOR_TYPES })
    }
  } catch (error) {
    console.log('FETCH SENSOR TYPES FAILED ', error)
  }
}

function* fetchSensorNames({ payload, promise }) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: UrlHelper.create(ApiRoute.SENSOR_NAMES, payload),
    })

    if (response && !response.hasOwnProperty('error')) {
      yield put({ type: SUCCESS_SENSOR_NAMES, payload: response })
    } else {
      yield put({ type: FAILURE_SENSOR_NAMES })
    }

    yield call(promise.resolve, response)
  } catch (error) {
    console.log('FETCH SENSOR NAMES FAILED ', error)
  }
}

function* fetchSiteTypes(action) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: UrlHelper.createQuery(
        ApiRoute.ACTIVE_SITE_TYPE_LIST,
        action.payload,
      ),
    })

    if (response && !response.hasOwnProperty('error')) {
      yield put({ type: SUCCESS_SITE_TYPES, payload: response })
    } else {
      yield put({ type: FAILURE_SITE_TYPES })
    }
  } catch (error) {
    console.log('FETCH SENSOR TYPES FAILED ', error)
  }
}

function* fetchSensorsData(action) {
  try {
    yield put({ type: SET_SENSORS_CHART_LOADER, payload: true })
    yield put({ type: REFRESH_SENSOR_CHART_DATA, payload: false })

    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: UrlHelper.create(ApiRoute.SENSORS_DATA, action.payload),
    })

    yield put({ type: SET_SENSORS_CHART_LOADER, payload: false })

    if (response && !response.hasOwnProperty('error')) {
      yield put({ type: SUCCESS_SENSORS_DATA, payload: response })
    } else {
      yield put({ type: FAILURE_SENSORS_DATA })
    }
  } catch (error) {
    console.log('FETCH SENSOR TYPES FAILED ', error)
  }
}

function* setCustomSensorLimits(action) {
  const { data, successMessage } = action.payload

  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: ApiRoute.SENSOR_SET_LIMITS,
      method: 'POST',
      data,
    })

    if (response && !response.hasOwnProperty('error')) {
      yield put({
        type: SHOW_NOTICE,
        notice: NoticeHelper.createSuccessObj(successMessage),
      })
      yield put({ type: REFRESH_SENSOR_CHART_DATA, payload: true })
    } else {
      yield put({
        type: SHOW_NOTICE,
        notice: NoticeHelper.createErrorObj(response.message),
      })
    }
  } catch (error) {
    console.log('SET CUSTOM SENSOR LIMITS FAILED ', error)
  }
}

function* sensorSaga() {
  yield takeLatest(FETCH_SITE_LIST, fetchSiteList)
  yield takeLatest(FETCH_SENSOR_TYPES, fetchSensorTypes)
  yield takeLatest(FETCH_SENSOR_NAMES, fetchSensorNames)
  yield takeLatest(FETCH_SITE_TYPES, fetchSiteTypes)
  yield takeLatest(FETCH_SENSORS_DATA, fetchSensorsData)
  yield takeLatest(SET_CUSTOM_SENSOR_LIMITS, setCustomSensorLimits)
}

export default sensorSaga
